<template>
    <div>
        <grid-select :settings="settings"
                     v-if="this.settings.type === 'select'"
                     @change="setValues($event.value, null)"
        />
        <date-range :settings="settings"
                    v-if="this.settings.type === 'dateRange'"
                    @change="setValues($event.value, $event.valueTo)"
        />
        <number-range :settings="settings"
                      v-if="this.settings.type === 'numberRange'"
                      @change="setValues($event.value, $event.valueTo)"
        />
        <input v-model="value"
               type="text"
               @keydown.esc="resetValue()"
               class="form-control form-control-sm"
               :placeholder="t('Search here')"
               v-if="isText === true"
        >
        <input v-model="value"
               type="number"
               @keydown.esc="resetValue()"
               class="form-control form-control-sm"
               :placeholder="t('Search here')"
               v-if="isNumber === true"
        >
    </div>
</template>
<script>
    import DateRange from "./filters/DateRange";
    import GridSelect from "./filters/Select";
    import NumberRange from '../DataGrid/filters/NumberRange';

    export default {
        components: {
            NumberRange,
            DateRange,
            GridSelect
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        },
        watch: {
            value(newValue, oldValue) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.value = this.value === '' ? null : this.value;
                    this.valueTo = this.valueTo === '' ? null : this.valueTo;
                    this.changed();
                }, 300);
            },
            valueTo(newValue, oldValue) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.value = this.value === '' ? null : this.value;
                    this.valueTo = this.valueTo === '' ? null : this.valueTo;
                    this.changed();
                }, 300);
            }
        },
        filters: {},
        computed: {
            isText() {
                return ['fulltext', 'stringNotEqual', 'stringEqual'].includes(this.settings.type);
            },
            isRange() {
                return ['numberRange', 'dateRange'].includes(this.settings.type);
            },
            isNumber() {
                return ['number'].includes(this.settings.type);
            }
        },
        methods: {
            setValues(value, valueTo) {
                this.value = value;
                this.valueTo = valueTo;
            },
            isEmpty() {
                return this.value === null && this.valueTo === null;
            },
            changed() {
                const content = this.isRange ? {from: this.value, to: this.valueTo} : this.value;
                if (this.isEmpty()) {
                    this.$emit('removed');
                } else {
                    this.$emit('changed', content);
                }
            },
            resetValue() {
                this.value = null;
                this.valueTo = null;
            }
        },
        data() {
            return {
                timeout: null,
                value: null,
                valueTo: null,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/core/InlineDataGrid/GridFilter.vue